import { Popover } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { CheckboxFilter } from './CheckboxFilter';
import { ICourse } from '@/shared/ICourse';
import React from 'react';

export const CheckboxFilterYear = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const options = React.useMemo(() => {
    // Extract years from folderName using regex (any 4-digit year starting with 20)
    const yearCounts = new Map<string, number>();
    
    props.allCourses?.forEach(course => {
      if (course.folderName) {
        const match = course.folderName.match(/20\d{2}/);
        if (match) {
          const year = match[0];
          yearCounts.set(year, (yearCounts.get(year) || 0) + 1);
        }
      }
    });

    return Array.from(yearCounts.entries())
      .map(([year, count]) => ({
        label: year,
        value: year,
        count
      }))
      .sort((a, b) => b.value.localeCompare(a.value)); // Sort descending (newest first)
  }, [props.allCourses]);

  const hasSelection = props.value !== undefined && props.value.length > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Year" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxFilter
          hideLabel
          value={props.value}
          onChange={(v) => props.onSetFilter(v)}
          options={options} />
      </FilterPopoverContent>
    </Popover>
  );
};
